import { apiFetch, apiFetchWithRetry } from '@/lib/apiFetch';
import type { WishlistItem } from '@/types/registeredStudent';
import { handleUnauthorized } from './UserManagmentServices';

const BASE = '/api/userManagement/v1/me/wishlist';

interface WishlistItemResponse {
  teacherHandle: string;
  teacherName: string;
  savedAt: string;
}

function toWishlistItem(r: WishlistItemResponse): WishlistItem {
  return { id: r.teacherHandle, teacherHandle: r.teacherHandle, teacherName: r.teacherName, savedAt: r.savedAt };
}

export async function getWishlist(accessToken: string): Promise<WishlistItem[]> {
  const res = await apiFetchWithRetry(BASE, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (res.status === 401) handleUnauthorized();
  if (!res.ok) throw new Error(`Failed to fetch wishlist: ${res.status}`);
  const data: WishlistItemResponse[] = await res.json();
  return data.map(toWishlistItem);
}

/** Returns 201 (new) or 200 (already saved). */
export async function addToWishlist(
  accessToken: string,
  teacherHandle: string,
  teacherName: string,
): Promise<WishlistItem> {
  const res = await apiFetch(BASE, {
    method: 'POST',
    headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ teacherHandle, teacherName }),
  });
  if (res.status === 401) handleUnauthorized();
  if (!res.ok) throw new Error(`Failed to save teacher: ${res.status}`);
  const data: WishlistItemResponse = await res.json();
  return toWishlistItem(data);
}

export async function removeFromWishlist(
  accessToken: string,
  teacherHandle: string,
): Promise<void> {
  const res = await apiFetch(`${BASE}/${encodeURIComponent(teacherHandle)}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (res.status === 401) handleUnauthorized();
  if (!res.ok && res.status !== 404) throw new Error(`Failed to remove teacher: ${res.status}`);
}
